// TODO: remove when .net core auth functionality is available
declare const window: LegacyReactWindow;

export function isBrowser() {
  return true;
}

export function navigateTo(url: string): void {
  window.location.href = url;
}

/**
 * @deprecated TODO: replace all of this with an API when .net core auth functionality is available
 */
export async function logout(): Promise<void> {
  const form = document.createElement('form');
  form.action = '/Account/LogOff';
  form.id = 'logoutForm';
  form.method = 'POST';

  const aftInput = document.createElement('input');
  aftInput.name = window.__root.antiForgery.cookieName;
  aftInput.value = window.__root.antiForgery.tokenValue;
  aftInput.hidden = true;

  form.appendChild(aftInput);

  await fetch(form.action, {
    method: form.method,
    body: new FormData(form),
    credentials: 'same-origin',
  });

  navigateTo(window.location.origin);
}

export function isHomepage() {
  return window.location.pathname === '/';
}
